import { render, staticRenderFns } from "./FieldType5.vue?vue&type=template&id=0a21f75a&scoped=true"
import script from "./FieldType5.vue?vue&type=script&lang=js"
export * from "./FieldType5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21f75a",
  null
  
)

export default component.exports